import React from 'react';
import { VersionType } from '@michelin/acid-components/build/components/Sidebar/Sidebar';
import { CentralProviderFooter, EXTERNAL_SITES, maestroApiCall } from '@michelin/central-provider';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { apigatewayBaseRoute, rubyApiBaseRoute } from 'services/restApiConst';
import { version } from '../../version.json';

export default function Footer() {
  const { t } = useTranslation();

  const { data: backendVersion } = useQuery<{ version?: string }>(
    ['get-be-version'],
    () =>
      maestroApiCall({
        method: 'GET',
        endpoint: 'version',
        baseURL: apigatewayBaseRoute,
      }),
    {
      cacheTime: 3600,
    },
  );

  const { data: rubyBackendVersion } = useQuery<{ version?: string }>(
    ['get-ruby-version'],
    () =>
      maestroApiCall({
        method: 'GET',
        endpoint: 'healthcheck',
        baseURL: `${rubyApiBaseRoute}/orders-v2/`,
      }),
    {
      cacheTime: 3600,
    },
  );

  const versions: VersionType[] = [
    {
      application: t('UI'),
      version,
    },
    {
      application: t('API'),
      version:
        backendVersion?.version && rubyBackendVersion?.version
          ? `${backendVersion.version.split('-')[1]}/${rubyBackendVersion.version.split('-')[1]}`
          : ` ${t('loading...')}`,
    },
  ];

  return (
    <CentralProviderFooter
      versions={versions}
      application="Urban Fleet Order"
      footerExternals={EXTERNAL_SITES}
      showLegalInformation
      showCopyright
    />
  );
}
